<template>
	<div class="bottom-bar row px-4"></div>
</template>

<script>
	export default {};
</script>
